import React from 'react';
import i18n from '@i18next/i18n';
import { ONE_COLUMN_ICON, THREE_COLUMN_ICON, TOOLBAR_COLUMN_ICON, TWO_COLUMN_ICON } from '@src/framework/editor/src/img/pageIndex';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { DropdownType } from '@src/framework/editor/src/js/constants/toolbar-data';
import { ToolbarConfig } from '@tencent/workbench';
import style from './style.less';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

interface ColumnItemProps {
    icon: string;
    text: string;
}
export const ColumnItem = ({ icon, text }: ColumnItemProps) => (
    <div className={style['column-item']}>
        <img src={icon} alt={text} />
        <span>{text}</span>
    </div>
);

export const config = {
    id: ActionType.COLUMNS,
    tipMsg: i18n.t('分栏'),
    icon: TOOLBAR_COLUMN_ICON,
    twdConfig: {
        action: TDWActionType.COLUMNS_NUMBER,
        handleFunction: value => ({
            ver5: value.columnNumber,
        }),
    },
    dropdown: {
        type: DropdownType.GRID,
        checkSelectedValue: true,
        columns: 1,
        menuStyle: {
            width: 'auto',
            ['min-width']: '80px',
        },
        data: [
            {
                id: 1,
                content: (
                    <ColumnItem icon={ONE_COLUMN_ICON} text={i18n.t('一栏')} />
                ),
            },
            {
                id: 2,
                content: (
                    <ColumnItem icon={TWO_COLUMN_ICON} text={i18n.t('两栏')} />
                ),
            },
            {
                id: 3,
                content: (
                    <ColumnItem icon={THREE_COLUMN_ICON} text={i18n.t('三栏')} />
                ),
            },
        ],
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={i18n.t('分栏')}/>,
        tooltip: config.tipMsg,
        hasArrow: true,
    },
];
